import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Zap } from 'lucide-react';

const Navbar = () => {
  const location = useLocation();
  const isDemo = location.pathname === '/quickbot-demo';
  const [activeSection, setActiveSection] = useState('hero');
  const [shouldPulseCTA, setShouldPulseCTA] = useState(false);

  const sections = [
    { id: 'hero', name: 'What' },
    { id: 'benefits', name: 'Why' },
    { id: 'buzz', name: 'Buzz' },
    { id: 'process', name: 'How' },
    { id: 'industries', name: 'Who' },
    { id: 'pricing', name: 'How much' }
  ];

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 100;
      const pricingSection = document.getElementById('pricing');
      
      // Check if we're past the pricing section
      let pastPricing = false;
      if (pricingSection) {
        const pricingBottom = pricingSection.offsetTop + pricingSection.offsetHeight;
        pastPricing = scrollPosition >= pricingBottom;
        setShouldPulseCTA(pastPricing);
      }
      
      // Set active section based on current position
      if (!pastPricing) {
        for (let i = sections.length - 1; i >= 0; i--) {
          const section = document.getElementById(sections[i].id);
          if (section && section.offsetTop <= scrollPosition) {
            setActiveSection(sections[i].id);
            break;
          }
        }
      } else {
        // Clear active section when past pricing
        setActiveSection('');
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Call once to set initial state
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (sectionId) => {
    setActiveSection(sectionId);
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="logo">
          QUICK<Zap size={32} style={{ margin: '0 2px', display: 'inline-block', verticalAlign: 'middle', color: '#1E40AF', transform: 'scaleY(1.1)', filter: 'drop-shadow(0 0 1px rgba(30, 64, 175, 0.3))' }} />BOT
        </Link>
        <ul className="nav-links">
          {isDemo ? (
            <>
              <li><Link to="/" className="active">Back to Home</Link></li>
            </>
          ) : (
            sections.map(section => (
              <li key={section.id}>
                <a 
                  href={`#${section.id}`}
                  className={activeSection === section.id ? 'active' : ''}
                  onClick={() => handleNavClick(section.id)}
                  style={section.id === 'pricing' ? { fontWeight: '700', color: '#1E40AF' } : {}}
                >
                  {section.name}
                </a>
              </li>
            ))
          )}
        </ul>
        <a 
          href="https://calendly.com/dimitrovovich" 
          target="_blank" 
          rel="noopener noreferrer" 
          className={`nav-cta ${shouldPulseCTA ? 'pulse' : ''}`}
        >
          Get Started
        </a>
      </div>
    </nav>
  );
};

export default Navbar;